
    import '/opt/buildhome/repo/packages/x/docs/x-markdown/components-sources.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-markdown-components-sources-demo-sources"],
  getter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-markdown/components-sources.en-US.md?type=demo')
};